// @ts-nocheck

export const localeCodes =  [
  "en",
  "ar"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_13a58af1",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_c09a45b3",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "English",
    dir: "ltr",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ar",
    language: "ar-SA",
    name: "العربية",
    dir: "rtl",
    domains: [],
    defaultForDomains: []
  }
]

